import { useNewLeadNotifier } from "@/hooks/call-center/useNewLeadNotification";
import { useInboundSmsNotifier } from "@/hooks/useInboundSmsNotifier";

/**
 * This component has no UI — it only mounts the global socket
 * listeners that trigger new-lead and inbound-SMS toast notifications.
 * Place it inside both SnackbarProvider and SocketProvider.
 */
const GlobalNotificationListener = () => {
    useNewLeadNotifier();
    useInboundSmsNotifier();
    return null;
};

export default GlobalNotificationListener;